const initialState = {
  index: [],
  data: {},
};

const Notification = (state = initialState, action) => {
  switch (action.type) {
    case "NOTIFICATION_INDEX":
      return { ...state, index: action.payload.index };
    case "NOTIFICATION_DATA":
      return { ...state, data: action.payload.data };
    case "NOTIFICATION_RESET":
      return initialState;
    default:
      return state;
  }
};

export default Notification;
